/**
 * Standalone translation utility
 * This can be used in any file without needing the React hook
 */

import LABELS, { LabelKey } from "../data/labels";
import { appGetItem } from "@/lib/auth-storage";

export function getCurrentLanguage(): 'en' | 'zh' {
  if (typeof window !== 'undefined') {
    const stored = appGetItem("jupas_language");
    if (stored === "zh" || stored === "en") {
      return stored;
    }
  }
  return "en";
}

/**
 * Translate a label key to the current language
 * @param key - The label key to translate
 * @param language - Optional language override ('en' or 'zh')
 * @returns The translated string
 */
export function translate(key: LabelKey, language?: 'en' | 'zh'): string {
  const lang = language || getCurrentLanguage();
  // console.log('translate:', key, '->', LABELS[key]?.[lang] || key);
  return LABELS[key]?.[lang] || key;
}

/**
 * Alias for translate function
 */
export const t = translate;
